module.exports = __webpack_public_path__ + "static/section-img3-59124743bacbd2884e9b536208aae0c2.png";